module.exports = __webpack_public_path__ + "static/media/CTLI_15-178w.b85c46a3.webp";